import { UseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'

import { getW8Document } from './api'
import { W8Document } from './types'

export const useW8Document = (
  options?: Omit<UseQueryOptions<W8Document | null>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<W8Document | null>({
    queryKey: ['w8-document'],
    queryFn: getW8Document,
    retry: false,
    ...options,
  })
